<h2>Bowel Sounds</h2>

<assessment-row title="RUQ">
  <p>{{ data.bowelSoundsRuq }}</p>
</assessment-row>

<assessment-row title="RLQ">
  <p>{{ data.bowelSoundsRlq }}</p>
</assessment-row>

<assessment-row title="LUQ">
  <p>{{ data.bowelSoundsLuq }}</p>
</assessment-row>

<assessment-row title="LLQ">
  <p>{{ data.bowelSoundsLlq }}</p>
</assessment-row>

<assessment-row title="Date of Last Bowel Movement">
  <p>{{ getDateString(data.dateLastBM) }}</p>
</assessment-row>

<assessment-row title="Nausea">
  <p>{{ data.nausea ? 'Yes' : 'No'}}</p>
</assessment-row>

<assessment-row title="Emesis">
  <p>{{ data.emesis }}</p>
</assessment-row>

<assessment-row title="Incontinence">
  <p>{{ data.incontinence ? 'Yes' : 'No'}}</p>
</assessment-row>

<h2>Ostomy</h2>

<assessment-row title="Stoma Site">
  <p>{{ data.ostomyStomaSite }}</p>
</assessment-row>

<assessment-row title="Output">
  <p>{{ data.ostomyOutput }}</p>
</assessment-row>

<h2>Hemorrhoids</h2>
<assessment-row title="Hemorrhoids">
  <p>{{ data.hemorrhoids }}</p>
</assessment-row>

<h2>Nutrition</h2>
<assessment-row title="Reduced Appetite">
  <p>{{ isReducedAppetite }}</p>
</assessment-row>

<assessment-row title="Oral Diet">
  <p>{{ data.oralDiet }}</p>
</assessment-row>

<assessment-row title="Tube Feed?">
  <p>{{ isTubeFeed }}</p>
</assessment-row>

@if (data.tubeFeed) {
<assessment-row title="Tube Type">
  <p>{{ data.tubeType }}</p>
</assessment-row>
<assessment-row title="How many hours since bag changed?">
  <p>{{ data.bagChangedHours }}</p>
</assessment-row>
<assessment-row title="Site Assessment">
  <p>{{ data.siteAssessment }}</p>
</assessment-row>
}